const namespace = "avatarSelection";

export const SELECT_IMAGE = `${namespace}.selectImage`;
export const CONFIRM = `${namespace}.confirm`;
